import React from "react";
import { Sliders, ToggleLeft, Shield } from "lucide-react";
import PageHeader from "../../components/PageHeader";

const FeatureFlags = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumb="Controle & Segurança"
        title="Gestão de Feature Flags"
        subtitle="Controle de ativação gradual de recursos e Billing V2"
      />

      <div className="neumorphic-card rounded-2xl p-8 border border-white/5 space-y-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-purple-500/10 border border-purple-500/20 text-purple-400 flex items-center justify-center">
            <Sliders size={24} />
          </div>
          <div>
            <h3 className="text-base font-bold text-white">Módulo em Integração</h3>
            <p className="text-xs text-gray-400 mt-0.5">
              Gerenciamento dinâmico de chaves de funcionalidade por empresa
            </p>
          </div>
        </div>

        <div className="p-4 rounded-xl bg-white/5 border border-white/5 space-y-3 text-xs text-gray-300">
          <span className="font-bold text-gray-200 uppercase tracking-wider text-[11px] block">
            Funcionalidades Previstas:
          </span>
          <ul className="space-y-2">
            <li className="flex items-center gap-2">
              <ToggleLeft size={14} className="text-purple-400" />
              <span>Controle de chaves do Billing V2 e gateways de pagamento</span>
            </li>
            <li className="flex items-center gap-2">
              <Sliders size={14} className="text-purple-400" />
              <span>Porcentagem de rollout gradual por grupo de tenants</span>
            </li>
            <li className="flex items-center gap-2">
              <Shield size={14} className="text-purple-400" />
              <span>Ativação de recursos beta sem necessidade de novo deploy</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FeatureFlags;
